export default {"src":"/_next/static/media/default-user.277dc377.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};